import inViewport from '@resources/js/helpers/inViewport'
import initGalleries from '@resources/js/components/galleries'
import Toggle from '@resources/js/ui/Toggle'

initGalleries()

const hotelCardElements = document.querySelectorAll('.js-hotel-card')

hotelCardElements.forEach(element => {
	inViewport(element, () => {
		new Toggle(element.querySelector('.js-amenities-list-toggle'), {
			target: element.querySelector('.js-amenities-list'),
		})

		const descriptionElement = element.querySelector('.js-desc-wrap')

		const isOverflowing =
			descriptionElement.scrollHeight > descriptionElement.clientHeight

		if (isOverflowing) {
			const descriptionToggleTriggerElement =
				element.querySelector('.js-desc-toggle')

			descriptionToggleTriggerElement.classList.remove('hidden')

			new Toggle(descriptionToggleTriggerElement, {
				target: descriptionElement,
			})
		}
	})
})
